<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <div style="font-size: 12px; font-weight: 700; margin-bottom: 10px">
      {{ tableName }}
    </div>
    <div
      style="
        overflow-x: auto;
        white-space: nowrap;
        display: flex;
        flex-direction: column;
        height: 100%;
      "
    >
      <div style="position: sticky; top: 0; z-index: 10">
        <table
          style="
            border-top: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            background: #f5f7fa;
          "
        >
          <colgroup>
            <col
              style="width: 150px"
              v-for="(text, textIndex) in previewData.data[0] || []"
              :key="textIndex"
            />
            <col />
          </colgroup>
          <thead>
            <tr v-for="(item, index) in previewData.header" :key="index">
              <th
                v-for="(text, textIndex) in item"
                :key="textIndex"
                :colspan="colspanFn(textIndex, index)"
                v-show="colspanFn(textIndex, index)"
              >
                {{ text }}
              </th>
              <th colspan="1"></th>
            </tr>
          </thead>
        </table>
      </div>
      <div style="flex: 1; height: 100%">
        <div style="height: 100%">
          <table style="border-left: 1px solid #ebeef5">
            <colgroup>
              <col
                style="width: 150px"
                v-for="(text, textIndex) in previewData.data[0] || []"
                :key="textIndex"
              />
              <col />
            </colgroup>
            <tbody>
              <tr v-for="(item, index) in previewData.data" :key="index">
                <th
                  v-for="(text, textIndex) in item"
                  :key="textIndex"
                  :colspan="
                    textIndex === 0 &&
                    index === previewData.data.length - 1 &&
                    previewVal.xFields.length
                      ? previewVal.xFields.length
                      : 1
                  "
                >
                  <div class="ellipsis">{{ text }}</div>
                </th>
                <th colspan="1"></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummarySheet",
  props: {
    previewData: {
      type: Object,
      default: () => ({
        header: [],
        data: [],
      }),
    },
    tableName: {
      type: String,
      default: "",
    },
    previewVal: {
      type: Object,
      default: () => ({
        xFields: [],
        yFields: [],
      }),
    },
  },
  methods: {
    getCountArray(headers) {
      const result = [];
      let currentHeader = null;
      let count = 0;

      headers.forEach((header, index) => {
        if (header === currentHeader) {
          count++;
        } else {
          currentHeader = header;
          count = 1;
        }

        // 如果是连续相同的最后一个元素，或者下一个元素不同，则记录计数
        if (index === headers.length - 1 || header !== headers[index + 1]) {
          result.push(count);
        } else {
          result.push(0);
        }
      });

      return result;
    },
    colspanFn(textIndex, index) {
      if (
        this.previewVal.xFields.length &&
        index < this.previewVal.yFields.length
      ) {
        if (textIndex === 0) {
          return this.previewVal.xFields.length;
        } else {
          const colspan = this.getCountArray(this.previewData.header[index]);
          return colspan[textIndex];
        }
      }
      return 1;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
  display: table;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}
table th {
  border-bottom: 1px solid #ebeef5;
  border-left: none;
  border-top: none;
  font-size: 13px;
  height: 34px;
  padding: 3px 10px;
  text-align: left;
  border-left: none;
  border-right: 1px solid #ebeef5;
  box-sizing: border-box;
  font-size: 13px;
  color: #1f1f1f;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>